<template>
    <form-row title="Have you Approved and Sent back your Loan Estimate?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_approved_loan_estimate"
                v-model="has_approved"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_approved"
                class="mt-4 sm:mt-0 sm:ml-12 flex flex-1 items-center sm:justify-end"
                label="Date Sent:"
                :value="mortgage.loan_estimate_approved_at"
                name="loan_estimate_approved_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_approved: this.mortgage.has_approved_loan_estimate,
        }
    },
}
</script>
